export const shuffleArray = (array) => {
  return array.sort(() => Math.random() - 0.5);
};
